/* eslint-disable @typescript-eslint/naming-convention */
import { AppVariables, TableModel } from '@shared';
import { RxJsonSchema } from 'rxdb';
import { WorkspaceDatabaseKeys } from './workspace-database-keys';

// todo: check which are nullable and set them nullable in rxdb
export const tableSchema: RxJsonSchema<TableModel> = {
	version: 0,
	primaryKey: WorkspaceDatabaseKeys.tables.tableName,
	properties: {
		[WorkspaceDatabaseKeys.tables.tableName]: {
			type: 'string',
			maxLength: AppVariables.PRIMARY_KEYS_MAX_LENGTH
		},
		[WorkspaceDatabaseKeys.tables.tableModule]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.tables.tabTitle]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.tables.tableId]: {
			type: 'number'
		},
		[WorkspaceDatabaseKeys.tables.standardTableName]: {
			type: ['string', 'null']
		},
		[WorkspaceDatabaseKeys.tables.childTableIds]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.tables.isIntervalRelated]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.tables.allowOverlap]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.tables.allowGaps]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.tables.allowDups]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.tables.dataMustStartAtZero]: {
			type: 'string'
		},
		[WorkspaceDatabaseKeys.tables.defaultRow]: {
			type: 'string'
		}
	},
	type: 'object',
	description: ''
};
